export const contactContent = {
  intro: "Notre premier échange me permettra de comprendre précisément le service dont vous avez besoin.",
  name: "L. Lobbardi",
  role: "Intervenante",
  phone: "06 77 45 38 37",
  email: "contact@proximiteconfiancefinistere.fr"
};